// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/udl-bg-female.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  background-color: #525252;
 
}

.nav-bar-div{
  width: 100%;
  height: 9em;
  background-image: linear-gradient(to right, #3870b8  , #333332);
  
}

.udl-logo{
  height: 7em;
  margin-left: 2em;
  margin: 1em;
}

.text-field{
  width:300px;
  height:36px;
  border: 1px solid #3870b8;

}

.udl-title{
  font-family: Arial;
  font-size: 50px;
  font-weight: normal;
  font-stretch: bold;
  
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #f7f7f7;
  margin : 1em;
}

.flags-bg{
  width: 100%;
  height: 5em;
  background-color: #333;
 
}

.choose-lng{
  margin-top: 0.5em;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
}

.footer-div{
  
  height: 4em;
  /* background-image: linear-gradient(273deg,#1293f6 108%,#5dd1ba -3%); */
  /* background-image: linear-gradient(to right, #5dd1ba, #1293f6); */
  background-image: linear-gradient(to right, #3870b8  , #21929b);
  /* border-top:5px solid #fec402; */
  padding : 0.1em;

  
  
}

@media only screen and (min-width: 1920px){
  .footer-div{
  
    height: 5em !important;
    width: 100%;
    /* background-image: linear-gradient(273deg,#1293f6 108%,#5dd1ba -3%); */
    /* background-image: linear-gradient(to right, #5dd1ba, #1293f6); */
    background-image: linear-gradient(to right, #3870b8  , #21929b);
    /* border-top:5px solid #fec402; */
    /* padding : 1em; */
   
    
    
  }

  .sd-row__question{
    height: fit-content;
    margin-top: 2em;
    padding-bottom: 3em !important;
  }

  .title_ba {
    background-color: #21929b;
    height: 4em;
    margin-left: -1.2em !important;
    margin-top: -1.7em;
    width: 30em;
    color: white;
    font-family: Arial;
    font-size: 20px;
    padding-left: 2em;
    padding-top: 0.5em;
    margin-bottom: 5px;
}



.myclassba {
  border: 1px solid black;
  width: 91%;
  margin-left: 0.3%;
  height: fit-content;
  padding-top: 1em;
  padding-bottom: 2em;
  padding-left: 3em;
  border-bottom: 7px solid #007ac0;
  font-weight: bold;
  font-size: 16px;
  white-space: initial;
  margin-bottom: 1em;
}



.sd-body {
  width: 100%;
  overflow-y: auto;
  
  /* z-index: 99999999 !important; */
  
}



}

.li-style{
  border-left: 1px solid #ffffff;
  height: 43px;
  padding: 5px;
  margin-left: 20px;
  
}

.li-text-style{
  font-family: Ubuntu;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #162e3a;
  padding-top: 20px;
}


.mainBoxStyle{
  width: 489px;
  height : 353px;
  padding: 12px 19px 23px 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);
  border: solid 1.1px #4abfa8;
  background-color: #4abfa8;
  
}

.startDiv {
  width: 315px;
  height: 330px;
  padding-left: 15%;
  padding-top: 10%;
  opacity: 0.8;
  border-radius: 6px;
  box-shadow: 0 4px 9px 1px rgba(65, 91, 104, 0.5);
  border: solid 2px #1293f6;
  background-color: #162e3a;
}

.yellowButton{

  width: 11em;
  height: 1.25em;
 
  border-radius: 10px;
  background-color: #f5c644;
  text-decoration: none;
  padding-bottom: 0.2em;
}

.yellowButtonText{
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;
  
}

.headingText{
 
  height: 37px;
  font-size: 33.8px;
  font-family: Ubuntu;
  font-size: 23.8px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: white;
}

.imageHover{
  
  background-color: orange;
}
.imageLeft {
  border : none;
}

.body-div{
  
  
  margin: 50px;
  
  
}

.box-outline{
  width: 25em;
  height: 25em;
  border: solid 4px #21929b;
}

.box-outline-sm{
  width: 300px;
  height: 379px;
  margin: 3px 0 0;
 
  border: solid 4px #21929b;
}

.box-outline:hover{
  width: 25em;
  height: 25em;
  border: solid 4px #f5c644;
}


.box-outline-lg{
  width: 70em;
  height: 516px;
 
  
  border: solid 4px #21929b;
 
}

.box-outline-lg-sm{
  width: 1058px;
  height: 516px;
 
  
  border: solid 4px #21929b;
 
}

.box-outline-lg:hover{
  width: 70em;;
  height: 516px;
 
  
  border: solid 4px #f5c644;
 
}


.box-outline-head{
  background-color: #21929b;
  height: 77px;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  
  color: #fff;
}

.box-outline-head:hover{
  background-color: #f5c644;
  height: 77px;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  
  color: #fff;
}

.intro-label{
  
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
}

.box-body-lg{
  width: 700px;
  height: 320px;
  margin-top: 5px;
  border-radius: 6px;
  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);
  border: solid 1.1px #f7f7f4;
  background-color: #f7f7f4;
  
}

.box-outline-yellow{
  width: 220px;
  height: 200px;
  padding: 12px 19px 33px 29px;
  border-radius: 6px;
  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);
  border: solid 1.1px #fec402 ;
  background-color: #fec402 ;
}

.box-body{
  width: 200px;
  height: 170px;
  margin-top: 5px;
  border-radius: 6px;
  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);
  border: solid 1.1px #f7f7f4;
  background-color: #f7f7f4;
  
}

.title-style{
 
  height: 27px;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  
  color: #fff;
  
}

.guess-class{
  background-color: #f1f1f1;
  width: 500px;
  height: 230px;
  padding: 20px;
  font-size: 20px;
}

.title-style-unbold{
  width: 348px;
  height: 27px;
  font-size: 1.3em;
  
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  
  color: #fff;
  
}

.title-bg{
  background-color: #21929b;
  height: 57px;
  text-align: center;
}

.title-bg:hover{
  background-color: #fec402;
  height: 57px;
  text-align: center;
}


.description-style{
 
 
  margin-top: 2%;
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  overflow-y: auto;
  padding: 10px;
}

.right-intro-div{
  width: 315px;
  height: 330px;
  margin: 0 0 0 442px;
  padding: 0px 14px 8px 12px;
  opacity: 0.8;
  border-radius: 6px;
  box-shadow: 0 4px 9px 1px rgba(65, 91, 104, 0.5);
  border: solid 2px #1293f6;
  background-color: #162e3a;
}

/* .intro-div{
  background-image: url(./images/udl-bg-female.png);
  background-repeat: no-repeat;
  width: 100%;
  padding-bottom: 20vh;
} */

.white-label{
  
  height: 22.5px;
  font-family: Ubuntu;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.94;
  letter-spacing: normal;
  color: #ffffff;
  text-align: center;
}

.bg-class{
  
  /* background-image: url('https://udl-boe.eu/wp-content/uploads/2021/05/cropped-homepage-3.jpg'); */
  width: 100%;
  padding-top: 10px;
  height: 900px;
  /* background-image: url('./images/udl-bg.PNG'); */
  background: rgb(2,0,36);

  background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(174,174,187,1) 35%, rgba(0,212,255,1) 100%);
 
background-repeat:round;
 
}

.sv_qstn .sq-root {
  border: 10px solid gray;
  border-left: 4px solid #18a689;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 30px;
}

.sq-root-ba{
  background-color: pink;
}

.title_ba{
  background-color: #21929b;
  height: 7em !important;
 
  margin-top: -1.7em;
  width: 30em;
  color: white;
  font-family: Arial;
  font-size: 20px;
  padding-left: 2em;
  padding-top: 0.5em;
  margin-bottom:5px;
  position: static;
  margin-left: -2em !important;


}

.radiogroup_item_control{
  visibility: hidden;
}




/* change this to selected default */

/* By default radio button class */



.uncheckedradio{
 
  width: 95%;
  height: 35px;
  margin-top: 10px;
  margin-left: 2%;
  margin-right: 25%;
  cursor: pointer;
  background-color: #e0e2e2;
  padding: -0.1em;
} 

.radioLabel{
  color: black;
  cursor: pointer;
  width: 100%;
  height: 25px;
  
  padding-top: 7px;
  margin-bottom: 10px;
  font-family: Ubuntu;
  font-size: 16px;
}



.uncheckedradio:checked{
  color: white;
}

.checkedradio{
  
  width: 95%;
  
  margin-top: 10px;
  margin-left: 2%;
  margin-right: 25%;
  /* color : white !important; */
  cursor: pointer;
}











.uthOye{
  
    color: black;
    cursor: pointer;
    background-color: pink;
    width: 100%;
    height: 40px;
    padding-left: 15px;
    padding-top: 10px;
    margin-bottom: 10px;
    color: white
  
}


.radioroot{
  cursor: pointer !important;
}



/* .checkedradio{
  background-color: #007ac0;
  width: 95%;
  height: 40px;
  margin-top: 10px;
  margin-left: 2%;
  margin-right: 25%;
  padding: 5px;
  cursor: pointer;
  
} */



.checked-label{
  /* background-color: pink; */
  height: 40px;
  color: #f1f1f1 !important;
  background-color: #007ac0;
  cursor: pointer;
}

.unchecked-label{
  background-color: olive;
  width: 100% !important;
  cursor: pointer;
}





/* on hover of selecting an option from list */
/* .default:hover{
  background-color: #007ac0;
  cursor: pointer !important;
} */

/* on hover of  label of option from*/


/* .sd-item__control-label:hover
{
 background-color: #007ac0;
 cursor: pointer;
} */






.checked{
  background-color: #007ac0;
  width: 95%;
  height: 40px;
  margin-top: 10px;
  margin-left: 2%;
  margin-right: 25%;
  padding: 5px;
  cursor: pointer !important;
  
}



/* This hides the radio butotn circles */
.sd-radio__decorator{
  visibility: hidden;
  
}

/* Culprit class */
.sd-selectbase__label{

cursor: pointer;  
}

/* .sd-item__control-label{
 

font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
font-style: normal;
font-weight: normal;
line-height: calc(3 * var(--base-unit, 8px));
font-size: calc(2 * var(--base-unit, 8px));
margin-left: calc(1 * var(--base-unit, 8px));
white-space: normal;
word-break: break-word;
background-color: yellow;

} */

.selectedradioclass{
 

  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  line-height: calc(3 * var(--base-unit, 8px));
  font-size: calc(2 * var(--base-unit, 8px));
  margin-left: calc(1 * var(--base-unit, 8px));
  white-space: normal;
  word-break: break-word;
  background-color: pink;
  
  }




.box-style{
  background-color: white;
  border: 1px solid black;
  height: 45px;
  margin-left: 20px;
}


.tick-style{
  font-weight: bold;
  font-family: Ubuntu;
  font-size: 30px;
  color: #162e3a;
  padding: 20px;
}

.rec-label{
  font-family: Ubuntu;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #18a689;
}

.head-style{
  font-family: Ubuntu;
  font-size: 44px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #18a689;
}


/* sd-description sd-question__description */
.sd-question__description-ba{
  
  border: 1px solid black;
  width: 40%;
  margin-left: 30%;
  height: 200px;
  padding: 25px;
  border-bottom: 7px solid #007ac0;
  font-weight: bold;
  
}

.myclassba{
  border: 1px solid black;
  width: 91%;
  /* margin-left: 10%; */
  height: fit-content;
  padding-top: 1em;
  padding-bottom: 1em;
  padding-left: 3em;
  border-bottom: 7px solid #007ac0;
  font-weight: bold;
  font-size: 16px;
  white-space: initial;
}

.default-checkbox{
  background-color: #f1f1f1;
  width: 90%;
  /* height: 150px; */
  margin-top: 10px;
  margin-left: 5%;
  margin-right: 25%;
  padding: 5px; 

  font-family: Ubuntu;
  font-size: 16px;
  
  
}

.default-checkbox:hover{
  background-color: #19b394;
  /* min-width: 200%; */
  /* height: 150px; */
  margin-top: 10px;
  margin-left: 5%;
  margin-right: 25%;
  padding: 5px; 
  color : white;
  height: fit-content;
  font-family: Ubuntu;
  font-size: 16px;
  font-weight: bold;
}



.sd-checkbox__decorator{
  visibility: hidden;
}

/* progress bar on top style class */
.sd-progress__bar{
height: 80px !important; 
/* background-color: #007ac0 !important; */
/* position: fixed !important; */


}

/* Hide the nouislider slider button to avoid UI issues */
.noUi-handle{
  
  visibility: hidden;
}

/* question title class */
.sv-string-viewer{
  white-space: initial;
  cursor: pointer;
  
  
}



.bg-class {
  /* background-image: url(https://udl-boe.eu/wp-content/uploads/2021/05/cropped-homepage-3.jpg); */
  /* width: 100%; */
  /* padding-top: 0px; */
  /* height: 900px; */
  /* background-image: url(./images/udl-bg.PNG); */
  /* background: rgb(2,0,36); */
  /* background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(174,174,187,1) 35%, rgba(0,212,255,1) 100%); */
  
  padding-top: 5px;
  height: 100%;
  
  background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(174,174,187,1) 35%, rgba(0,212,255,1) 100%);
}



.inner-circle{
  width: 76px;
  height: 76px;
  margin: 0 43px 29px 41px;
  background-image: linear-gradient(312deg, #1293f6 104%, #5dd1ba -2%);
  border-radius: 50%;
  z-index: 5;
  position: relative;
}

.outer-circle{
background-color: #5dd1ba;
width: 86px;
  height: 86px;
  border-radius: 50%;
  position: absolute;
  top: 19%;
  left: 2.9%;
  z-index: 4;
}

.outer-2nd-circle{
  background-color: #5dd1ba;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    position: absolute;
    top: 18.2%;
    left: 2.6%;
    position: absolute;
    z-index: 3;
    opacity: 0.5;
}

/* Input Text Fields, change design using their specific ids  */


  .main-section {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    height: 37em;
  }


 

  /* FOR SMALL SCREENS */
  @media only screen and (max-width: 1919px)
   
 
   
 
   
 
   {

    

    .footer{
        
      border: 2px solid black;
      position: fixed !important;
      bottom: 0;
    }

    .surveybox{
       
        height: 50em !important;
    }

    .demographicbox{
      height: 350em !important;
      z-index: inherit;
      overflow-y: scroll;
    }

    .title-style-unbold{
      width: 348px;
      height: 27px;
      font-size: 0.9em;
      
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      
      color: #fff;
      
    }

    .results-head {
      width: 100%;
      height: 91px;
      text-align: center;
      background-color: #21929b;
      padding-top: 1%;
      
  }

    .surveybox{
      
      overflow-y: auto;
    }


    .sd-row__question {
      box-sizing: border-box;
      width: 100%;
      white-space: nowrap;
      height: fit-content !important;
      margin-top: 20px;
      padding-bottom: 3em !important;
    }


    .box-outline-lg {
      width: 70em;
      height: 18.7em;
      border: solid 4px #21929b;
  }

  .box-outline-lg:hover{
    height: 18.7em;
  }

  .title_ba {
    background-color: #21929b;
    height: 4em;
    margin-left: -2.0em;
    margin-top: -1.7em;
    width: 30em;
    color: white;
    font-family: Arial;
    font-size: 20px;
    padding-left: 2em;
    padding-top: 0.5em;
    margin-bottom: 5px;
    
}

.myclassba {
  border: 1px solid black;
  width: 91%;
  margin-left: 0.3%;
  height: fit-content;
  padding-top: 1em;
  padding-bottom: 2em;
  padding-left: 3em;
  border-bottom: 7px solid #007ac0;
  font-weight: bold;
  font-size: 16px;
  white-space: initial;
  margin-bottom: 1em;
 
}

  .intro-label {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
}

 



  .affiliation-div
{
  height: 2em  !important;
  background-image: linear-gradient(to right, #f5c644  , orange); 
}

 

  .btn-main-section{
      margin-top:-13px;
  }

  .nav-bar-div{
    width: 100%;
    height: 6em;
    background-image: linear-gradient(to right, #3870b8  , #333332);
    
  }

  /* 1920 */
  .udl-logo{
    height: 3.5em;
    margin-left: 2em;
  }

  .udl-title{
    font-family: Arial;
    font-size: 32px;
    font-weight: bold;
    font-stretch: normal;
    
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #f7f7f7;
    margin : 1em;
  }

  .flags-bg {
    width: 100%;
    height: 4em;
    background-color: #333;
}




  .main-section {
    background-color: lightblue;
    height: 28em;
  }

  .box-outline{
    margin-top: -20px;
    width: 17em;
    height: 15em;
    border: solid 4px #21929b;
  }

  .box-outline:hover{
    width: 17em;
    height: 15em;
    border: solid 4px #f5c644;
  }

  .title-bg{
    background-color: #21929b;
    height: 3em;
    text-align: center;
  }

  .title-style{
 
    
    font-size: 1.2em;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    
    color: #fff;
    
  }


  .description-style{
 
 
    margin-top: 2%;
    font-size: 0.9em;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    overflow-y: auto;
    padding: 10px;
  }


  .footer-div{
    position: fixed;
    bottom:0;
    width: 100%;
   }

   .affiliation-div{
    border:1px solid red;
    position: fixed;
    bottom:4em !important;
   }



   .dynoersmaindiv{
      
    margin-left: 5em !important;
    overflow-y: auto;
    
  }

  .results-bar-2{
   
    height: 340em !important;
  }

  .smallscreenfooter{
    border: 10px solid red;
    display: none;
  }

  .sd-progress__bar {
    height: 10px !important;
}


  }









  .intro-div{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    height: 47em !important;
   
  }







.results-head{
  width: 100%;
  height: 121px;
  text-align: center;
  background-color: #21929b;
  padding-top: 1%;
}

.results-subhead{
  width: 100%;
  height: 75px;
  
  background-color: #5aaeb5;
}

.likert-style{
  width: 191px;
  height: 42px;
  padding-top: 0.7%;
  background-color: #cb300d;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}


.results-donut{
  width: 100%;
  height: 20em;

  background-color: #b0d8dc;

  padding-top: 3em;
}

.donut-box{
  width: 25em;
  height: 229px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  
}

.overview-lbl{
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;

}


.overview-lbl-unb{
  font-size: 28px;

  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;

}


.overview-lbl-sm{
  font-size: 1.2  em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;
  
}

.donut-style{
  width: 234px;
  height: 118px;
  object-fit: contain;
  margin-top: 5%;
}

.results-bar{
  width: 99.5%;
  height: 289px;
  
  border: solid 4px #21929b;
  background-color: #fff;
}

.results-bar-2{
  width: 99.5%;
  height: 590px;
  
  border: solid 4px #21929b;
  background-color: #fff;
}

.bar-div{
  width: 485px;
  height: 211px;
  


}

.yellowButton-sm{
  
  height: 56px;
  padding: 14px 45px 13px;
  border-radius: 10px;
  background-color: #f5c644;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;
  text-decoration: none;
  cursor: pointer;
}

.noUi-connect{
background: #19b394 !important;
}



.testingclassess{
  background-color: oldlace;
}




















.launch-btn{
  width: 257px;
  height: 56px;
  border-radius: 10px;
  border: solid 3px black;
  background-color: #f5c644;
  
}

.launch-btn-text{
  width: 220px;
  height: 39px;
  font-family: Ubuntu;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;
  text-decoration: none;
  padding: 9px 18px 8px 19px;
}






iframe {
  border: 10px solid black;
}


.HeadingText{
 
  font-family: Ubuntu;
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  padding: 15px;
  text-decoration: none;
}

.cookie-btn{
  background: rgb(255, 212, 45);
    border: 0px;
    border-radius: 0px;
    box-shadow: none;
    color: black;
    cursor: pointer;
    flex: 0 0 auto;
    padding: 5px 10px;
    margin: 17px;
  
}



/* Remove page number appearing for pages of survey */
.sd-progress__text{
  display: none;
}



/* Media Query for Survey questions*/
@media only screen and (min-width: 1920px)
 {

  .results-bar-2{
      
      height: 242em ;
  }

  .footer{
      width: 100% ;
  }

  .intro-div{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    height : 70em !important;
   
  }
  .main-section {
   height: 70em;
  }

  /* .demographicbox{ */
    /* border : 20px solid orange; */
    /* height: 195em; */
    /* z-index: 100000 !important; */
  /* } */

}



.sv-radio-checked .sv-radio-svg{
  background-color: red !important;
  color : white !important;
}






.affiliation-div
{
  height: 5em;
  background-image: linear-gradient(to right, #f5c644  , orange);
  padding : 0.5em;
}

.affiliation-div p {

  font-family: Ubuntu;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #333;
  margin-left: 10px;
  margin-top:0px;
}


.sd-body{
margin-top: -40px;

background-color: #525252;
/* z-index: 99999999 !important; */

}


.sd-root-modern {
  --sd-mobile-width: 600px;
  width: 100%;
  font-family: 'Ubuntu';
  background-color: var(--background-dim, #f3f3f3);
}

.radioLabel:hover{
  color: white;
  cursor: pointer;
  background-color: #19b394;
  width: 100%;
  height: 25px;
  padding-left : 1.6em;
  padding-bottom: 0.2em;
  margin-left : -1.6em;  
  font-weight: bold;
 
}






.checked-checkbox{
  background-color: #19b394;
  min-width: 90%;
  /* height: 150px; */
  margin-top: 10px;
  margin-left: 5%;
  margin-right: 25%;
  padding: 5px; 
  
  color : white;

  height: fit-content;
  font-family: Ubuntu;
  font-size: 16px;
  font-weight: bold;
 
}

.sd-dropdown.sd-input{
  background-color: pink;

}

.sd-dropdown.sd-input:hover{
  background-color :#19b394;
  font-size: 16px;
  font-weight: bold;
  color : white;
  
}

.sd-dropdown.sd-input{
  background-color: #19b394;
  font-weight: bold;
  font-size: 16px;
  color : white !important;
  height: 3.3em;
  
}



/* .sv_q_text_root{
  background-color: #19b394 !important;
  width : 21em;
  height: 50px;
  color: white;
  font-family: Ubuntu;
  font-weight: bold;
  font-size: 25px;
} */

/* https://stackoverflow.com/questions/4113965/css-selector-for-text-input-fields */
/* Answe on this link, help to sort out issue of input text field */
[type=text]{
  height: 50px !important;
  width: 35em !important;
  background-color: #19b394;
  font-weight: bold;
  font-size: 25px;
  color : white;
}



  .oer-parent{
    width: 22em;
    height: 28em;
    margin-left: 15px;
    margin-top: 15px;
    border: solid 4px #e0e2e2;
    background-color: #fff;
    border : 1px solid black;
  }

  .oer-subhead{
    width: 22em;
    height: 5em;
    background-color: #e0e2e2;
    display: flex;
  }

  .oer-img{
    width: 3em;
    height: 3em;
    object-fit: contain;
    padding : 0.5em;
  }

  .oer-title-style{
    width: 20em;
    height: 122px;
    padding: 0.5em;
    font-family: Ubuntu;
    font-size: 1.2em;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: var(--black);
  }

  .oer-cluster{
    width: 22em;
    height: 2.5em;
    background-color: #705c98;
    display: flex;
    justify-content: center;
    padding-top: 0.5em;
  }

  .cluster-text{
  
    
    font-family: Ubuntu;
    font-size: 1.4em;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #fff;
    
  }

  .oer-details{
    width: 20em;
    height: 170px;
    margin: 25px 28px 25px 19px;
    font-family: Ubuntu;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: var(--black);
   
  }


  .selectlangclass{
    width: 15em;
    height: 1.5em;
    font-family: Ubuntu;
    font-size: 1.4em;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    background-color: #f5c644;
   
  }

  .selectlangclass option{
    background-color: #21929b;
    
    
  }



  /* Page box class for surveyjs September 2022 */
  .sd-page{
    
    margin-top: -60px;
    height: fit-content;
    
    
  }

  .sd-btn{
    margin-top: -30px;
    
    height: 2.5em !important;
    background-color: #f5c644 !important;
    font-family: Ubuntu !important;
    color: black !important;
    font-size: 22px !important;
    border: 1px solid orange !important;
   
  }

  .sd-btn:hover{
    background-color:  orange !important;
    border: 1px solid orange !important;
  }

 

 


  /* Options Section in Multiple Choice UDL BOE Question */
  .sd-question__content{
    
    margin-bottom: -35px;
    margin-top: -10px;
  }

  

  .sd-description{
    
    font-family: Ubuntu !important;
    color: white !important;
    font-size: 22px !important;
    font-weight: bold !important;
    
    padding-top: 5px;
  }
 

.noUi-value{
    
    font-family: Ubuntu !important;
    font-size: 22px !important;
    font-weight: bold !important;

}






.yellowButton:hover{
  background-color: orange;
}

.yellowButton-sm:hover{
  background-color: orange;
}

.launch-btn:hover{
  background-color: orange;
}


.launch-btn-text-new{
  width: 220px;
  height: 29px;
  font-family: Ubuntu;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;
  text-decoration: none;
  padding: 0px 18px 8px 19px;
}


/* .radioLabel .default-checkbox .oer-details .oer-details{
  font-weight: bold !important;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
  background-color: pink !important;
} */

 .oer-details{
  
  font-family: Ubuntu !important;
}

.oer-title-style{
  font-family: Ubuntu !important;
}

.radioLabel{
  font-family: Ubuntu !important;
}

.default-checkbox {
  font-family: Ubuntu !important;
}


@media only screen and (max-height: 1080px) and (min-width: 1920px){
  .title_ba {
    background-color: #21929b;
    height: 4em;
    margin-top: -1.7em;
    width: 30em;
    color: white;
    font-family: Arial;
    font-size: 20px;
    margin-bottom: 5px;
    position: static;
    margin-left: -2em !important;
}


}



/* VERY LARGE SCREEN */
@media only screen and (min-width: 2560px){
  .results-bar-2{
      
    height: 182em !important;
  }

 /* VERY LARGE SCREEN */
@media only screen and (min-width: 2560px){
  .results-bar-2{
      
    height: 182em !important;
  }

 



}

.yellowButtonText {
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #333;
}



}



.sd-footer{


justify-content: right;
}



.table{
  border: 2px solid black;
  width: 100%;
}

.tr{
  border: 2px solid black;
}

.td{
  border: 2px solid black;
}



.checkedradio .radioLabel{
  background-color: #19b394;
  color: white;
  font-weight: bold;
  padding-left : 1.6em;
  height: 30px;
  margin-left : -1.5em;
  width: 200% !important;
}


.sd-progress-buttons__list{
/* background-color: pink; */
/* display: none !important; */
margin-bottom: 20px !important;

}


.sd-progress-buttons__footer .sd-progress-buttons__page-title{
 background-color: red;
 display: none 
}


.sv-components-row>.sv-components-column--expandable{
  background-color: #525252 !important;
}




.checkedradio .radioLabel{
  background-color: #19b394;
  color: white;
  font-weight: bold;
  height: 30px;
  
  width: 30em !important;
  margin-left: -2em !important;
}


.radioLabel:hover{
  background-color: #19b394;
  color: white;
  font-weight: bold;
  height: 30px; 
  
  width: 30em !important;
  margin-left: -2em !important;

}




.sd-progress-buttons__list .sd-progress-buttons__list-element--current .sd-progress-buttons__button .sd-progress-buttons__button-content {
  border: calc(0.5 * (var(--sjs-base-unit, var(--base-unit, 18px)))) solid var(--sjs-primary-backcolor, var(--primary, #19b394));
  background-color: var(--sjs-primary-forecolor, var(--primary-foreground, #fff));
  opacity: 1;
}





  .radioLabel{
    /* border: 2px solid red; */
    width: 30em !important;
    margin-left: -30px;
    padding-left: 25px;
    
  }


  /* Final change for consistency of hover */
.radioLabel:hover .uncheckedradio:hover {
  background-color: rgb(192, 255, 218);
  color: red;
  font-weight: bold;
  padding: 500px !important;
  }


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+DAA+D;;AAEjE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;;AAE3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;;EAElB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;;AAExB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,wEAAwE;EACxE,mEAAmE;EACnE,+DAA+D;EAC/D,kCAAkC;EAClC,eAAe;;;;AAIjB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,WAAW;IACX,wEAAwE;IACxE,mEAAmE;IACnE,+DAA+D;IAC/D,kCAAkC;IAClC,mBAAmB;;;;EAIrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;;;AAIA;EACE,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EAEjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;;;AAIA;EACE,WAAW;EACX,gBAAgB;;EAEhB,kCAAkC;;AAEpC;;;;AAIA;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;;AAEnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,qDAAqD;EACrD,2BAA2B;EAC3B,yBAAyB;;AAE3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gDAAgD;EAChD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,cAAc;;EAEd,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;;AAEb;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;;;EAGE,YAAY;;;AAGd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;;EAEf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,aAAa;;;EAGb,yBAAyB;;AAE3B;;AAEA;EACE,aAAa;EACb,aAAa;;;EAGb,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,aAAa;;;EAGb,yBAAyB;;AAE3B;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;;EAEtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;;EAEtB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,2BAA2B;EAC3B,yBAAyB;;AAE3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,qDAAqD;EACrD,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,2BAA2B;EAC3B,yBAAyB;;AAE3B;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;;EAEtB,WAAW;;AAEb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;;EAEhB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;;EAEtB,WAAW;;AAEb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;;;EAGE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,gDAAgD;EAChD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;GAKG;;AAEH;;EAEE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mGAAmG;EACnG,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kDAAkD;EAClD,uBAAuB;;EAEvB,sGAAsG;;AAExG,uBAAuB;;AAEvB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;;EAEtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;;;AAG9B;;AAEA;EACE,kBAAkB;AACpB;;;;;AAKA,oCAAoC;;AAEpC,kCAAkC;;;;AAIlC;;EAEE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;;;AAIA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;;EAEV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;AACjB;;;;;;;;;;;;AAYA;;IAEI,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB;;AAEJ;;;AAGA;EACE,0BAA0B;AAC5B;;;;AAIA;;;;;;;;;;GAUG;;;;AAIH;EACE,4BAA4B;EAC5B,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;;;;;AAMA,8CAA8C;AAC9C;;;GAGG;;AAEH,qCAAqC;;;AAGrC;;;;GAIG;;;;;;;AAOH;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;;AAE5B;;;;AAIA,wCAAwC;AACxC;EACE,kBAAkB;;AAEpB;;AAEA,kBAAkB;AAClB;;AAEA,eAAe;AACf;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;;EAGE,wEAAwE;EACxE,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,0CAA0C;EAC1C,4CAA4C;EAC5C,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;;EAEtB;;;;;AAKF;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;;AAGA,4CAA4C;AAC5C;;EAEE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,iBAAiB;;AAEnB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EAEtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;;EAEZ,mBAAmB;EACnB,eAAe;;;AAGjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;AACA,uBAAuB;AACvB,0CAA0C;AAC1C,gCAAgC;;;AAGhC;;AAEA,yDAAyD;AACzD;;EAEE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,eAAe;;;AAGjB;;;;AAIA;EACE,iGAAiG;EACjG,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gDAAgD;EAChD,6BAA6B;EAC7B,4GAA4G;;EAE5G,gBAAgB;EAChB,YAAY;;EAEZ,sGAAsG;AACxG;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oEAAoE;EACpE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;AACA,yBAAyB;AACzB,WAAW;EACT,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA,+DAA+D;;;EAG7D;IACE,yDAAiD;IACjD,sBAAsB;IACtB,YAAY;EACd;;;;;EAKA,sBAAsB;EACtB;;;;;;;;;;;IAWE;;MAEE,uBAAuB;MACvB,0BAA0B;MAC1B,SAAS;IACX;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;MACE,wBAAwB;MACxB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ,gBAAgB;;MAEhB,oBAAoB;MACpB,kBAAkB;MAClB,mBAAmB;MACnB,sBAAsB;;MAEtB,WAAW;;IAEb;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,yBAAyB;MACzB,eAAe;;EAEnB;;IAEE;;MAEE,gBAAgB;IAClB;;;IAGA;MACE,sBAAsB;MACtB,WAAW;MACX,mBAAmB;MACnB,8BAA8B;MAC9B,gBAAgB;MAChB,8BAA8B;IAChC;;;IAGA;MACE,WAAW;MACX,cAAc;MACd,yBAAyB;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EAEjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;;AAEpB;;EAEE;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;AACf;;;;;;EAME;;EAEA,uBAAuB;EACvB,8DAA8D;AAChE;;;;EAIE;MACI,gBAAgB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,+DAA+D;;EAEjE;;EAEA,SAAS;EACT;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;;IAEpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,sBAAsB;AAC1B;;;;;EAKE;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;;;IAGE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;;IAEtB,WAAW;;EAEb;;;EAGA;;;IAGE,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;;EAGA;IACE,eAAe;IACf,QAAQ;IACR,WAAW;GACZ;;GAEA;IACC,oBAAoB;IACpB,eAAe;IACf,qBAAqB;GACtB;;;;GAIA;;IAEC,2BAA2B;IAC3B,gBAAgB;;EAElB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,uBAAuB;AAC3B;;;EAGE;;;;;;;;;;EAUA;IACE,yDAAiD;IACjD,sBAAsB;IACtB,uBAAuB;;EAEzB;;;;;;;;AAQF;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,YAAY;;EAEZ,yBAAyB;;EAEzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2CAA2C;EAC3C,sBAAsB;;AAExB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;;AAEb;;;AAGA;EACE,eAAe;;EAEf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;;AAEb;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;;AAEb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;;;;AAIf;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;AACA,8BAA8B;AAC9B;;;;AAIA;EACE,yBAAyB;AAC3B;;;;;;;;;;;;;;;;;;;;;AAqBA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;;AAE3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,0BAA0B;AAC5B;;;;;;;AAOA;EACE,wBAAwB;AAC1B;;;AAGA;;EAEE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;IAC3B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,YAAY;;AAEhB;;;;AAIA,qDAAqD;AACrD;EACE,aAAa;AACf;;;;AAIA,oCAAoC;AACpC;;;EAGE;;MAEI,cAAc;EAClB;;EAEA;MACI,YAAY;EAChB;;EAEA;IACE,yDAAiD;IACjD,sBAAsB;IACtB,wBAAwB;;EAE1B;EACA;GACC,YAAY;EACb;;EAEA,qBAAqB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gCAAgC;EAClC,MAAM;;AAER;;;;AAIA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;;;;;;AAOA;;EAEE,WAAW;EACX,8DAA8D;EAC9D,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;AACA,iBAAiB;;AAEjB,yBAAyB;AACzB,kCAAkC;;AAElC;;;AAGA;EACE,wBAAwB;EACxB,WAAW;EACX,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;;AAEnB;;;;;;;AAOA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;;EAEZ,aAAa;;EAEb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,aAAa;;AAEf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,aAAa;;AAEf;;;;AAIA;;;;;;;;GAQG;;AAEH,mFAAmF;AACnF,mEAAmE;AACnE;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;;;EAIE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;;EAEb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;;EAErB;;;EAGA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;EAE3B;;EAEA;IACE,yBAAyB;;;EAG3B;;;;EAIA,+CAA+C;EAC/C;;IAEE,iBAAiB;IACjB,mBAAmB;;;EAGrB;;EAEA;IACE,iBAAiB;;IAEjB,wBAAwB;IACxB,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;IACvB,0BAA0B;IAC1B,mCAAmC;;EAErC;;EAEA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;;;;;;;EAOA,wDAAwD;EACxD;;IAEE,oBAAoB;IACpB,iBAAiB;EACnB;;;;EAIA;;IAEE,8BAA8B;IAC9B,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;;IAE5B,gBAAgB;EAClB;;;AAGF;;IAEI,8BAA8B;IAC9B,0BAA0B;IAC1B,4BAA4B;;AAEhC;;;;;;;AAOA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,0BAA0B;AAC5B;;;AAGA;;;;GAIG;;CAEF;;EAEC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;EACE;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;;AAGA;;;;AAIA,sBAAsB;AACtB;EACE;;IAEE,wBAAwB;EAC1B;;CAED,sBAAsB;AACvB;EACE;;IAEE,wBAAwB;EAC1B;;;;;;AAMF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;;;AAIA;;;;AAIA;;;AAGA,sBAAsB;AACtB;;;;AAIA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;;AAGA;AACA,4BAA4B;AAC5B,8BAA8B;AAC9B,8BAA8B;;AAE9B;;;AAGA;CACC,qBAAqB;CACrB;AACD;;;AAGA;EACE,oCAAoC;AACtC;;;;;AAKA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;;EAEZ,sBAAsB;EACtB,4BAA4B;AAC9B;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;;EAEZ,sBAAsB;EACtB,4BAA4B;;AAE9B;;;;;AAKA;EACE,8HAA8H;EAC9H,+EAA+E;EAC/E,UAAU;AACZ;;;;;;EAME;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;;EAEpB;;;EAGA,0CAA0C;AAC5C;EACE,oCAAoC;EACpC,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB","sourcesContent":["body{\r\n  background-color: #525252;\r\n \r\n}\r\n\r\n.nav-bar-div{\r\n  width: 100%;\r\n  height: 9em;\r\n  background-image: linear-gradient(to right, #3870b8  , #333332);\r\n  \r\n}\r\n\r\n.udl-logo{\r\n  height: 7em;\r\n  margin-left: 2em;\r\n  margin: 1em;\r\n}\r\n\r\n.text-field{\r\n  width:300px;\r\n  height:36px;\r\n  border: 1px solid #3870b8;\r\n\r\n}\r\n\r\n.udl-title{\r\n  font-family: Arial;\r\n  font-size: 50px;\r\n  font-weight: normal;\r\n  font-stretch: bold;\r\n  \r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #f7f7f7;\r\n  margin : 1em;\r\n}\r\n\r\n.flags-bg{\r\n  width: 100%;\r\n  height: 5em;\r\n  background-color: #333;\r\n \r\n}\r\n\r\n.choose-lng{\r\n  margin-top: 0.5em;\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n}\r\n\r\n.footer-div{\r\n  \r\n  height: 4em;\r\n  /* background-image: linear-gradient(273deg,#1293f6 108%,#5dd1ba -3%); */\r\n  /* background-image: linear-gradient(to right, #5dd1ba, #1293f6); */\r\n  background-image: linear-gradient(to right, #3870b8  , #21929b);\r\n  /* border-top:5px solid #fec402; */\r\n  padding : 0.1em;\r\n\r\n  \r\n  \r\n}\r\n\r\n@media only screen and (min-width: 1920px){\r\n  .footer-div{\r\n  \r\n    height: 5em !important;\r\n    width: 100%;\r\n    /* background-image: linear-gradient(273deg,#1293f6 108%,#5dd1ba -3%); */\r\n    /* background-image: linear-gradient(to right, #5dd1ba, #1293f6); */\r\n    background-image: linear-gradient(to right, #3870b8  , #21929b);\r\n    /* border-top:5px solid #fec402; */\r\n    /* padding : 1em; */\r\n   \r\n    \r\n    \r\n  }\r\n\r\n  .sd-row__question{\r\n    height: fit-content;\r\n    margin-top: 2em;\r\n    padding-bottom: 3em !important;\r\n  }\r\n\r\n  .title_ba {\r\n    background-color: #21929b;\r\n    height: 4em;\r\n    margin-left: -1.2em !important;\r\n    margin-top: -1.7em;\r\n    width: 30em;\r\n    color: white;\r\n    font-family: Arial;\r\n    font-size: 20px;\r\n    padding-left: 2em;\r\n    padding-top: 0.5em;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n\r\n\r\n.myclassba {\r\n  border: 1px solid black;\r\n  width: 91%;\r\n  margin-left: 0.3%;\r\n  height: -moz-fit-content;\r\n  height: fit-content;\r\n  padding-top: 1em;\r\n  padding-bottom: 2em;\r\n  padding-left: 3em;\r\n  border-bottom: 7px solid #007ac0;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  white-space: initial;\r\n  margin-bottom: 1em;\r\n}\r\n\r\n\r\n\r\n.sd-body {\r\n  width: 100%;\r\n  overflow-y: auto;\r\n  \r\n  /* z-index: 99999999 !important; */\r\n  \r\n}\r\n\r\n\r\n\r\n}\r\n\r\n.li-style{\r\n  border-left: 1px solid #ffffff;\r\n  height: 43px;\r\n  padding: 5px;\r\n  margin-left: 20px;\r\n  \r\n}\r\n\r\n.li-text-style{\r\n  font-family: Ubuntu;\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: right;\r\n  color: #162e3a;\r\n  padding-top: 20px;\r\n}\r\n\r\n\r\n.mainBoxStyle{\r\n  width: 489px;\r\n  height : 353px;\r\n  padding: 12px 19px 23px 20px;\r\n  border-radius: 6px;\r\n  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);\r\n  border: solid 1.1px #4abfa8;\r\n  background-color: #4abfa8;\r\n  \r\n}\r\n\r\n.startDiv {\r\n  width: 315px;\r\n  height: 330px;\r\n  padding-left: 15%;\r\n  padding-top: 10%;\r\n  opacity: 0.8;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 9px 1px rgba(65, 91, 104, 0.5);\r\n  border: solid 2px #1293f6;\r\n  background-color: #162e3a;\r\n}\r\n\r\n.yellowButton{\r\n\r\n  width: 11em;\r\n  height: 1.25em;\r\n \r\n  border-radius: 10px;\r\n  background-color: #f5c644;\r\n  text-decoration: none;\r\n  padding-bottom: 0.2em;\r\n}\r\n\r\n.yellowButtonText{\r\n  font-size: 36px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n  \r\n}\r\n\r\n.headingText{\r\n \r\n  height: 37px;\r\n  font-size: 33.8px;\r\n  font-family: Ubuntu;\r\n  font-size: 23.8px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: white;\r\n}\r\n\r\n.imageHover{\r\n  \r\n  background-color: orange;\r\n}\r\n.imageLeft {\r\n  border : none;\r\n}\r\n\r\n.body-div{\r\n  \r\n  \r\n  margin: 50px;\r\n  \r\n  \r\n}\r\n\r\n.box-outline{\r\n  width: 25em;\r\n  height: 25em;\r\n  border: solid 4px #21929b;\r\n}\r\n\r\n.box-outline-sm{\r\n  width: 300px;\r\n  height: 379px;\r\n  margin: 3px 0 0;\r\n \r\n  border: solid 4px #21929b;\r\n}\r\n\r\n.box-outline:hover{\r\n  width: 25em;\r\n  height: 25em;\r\n  border: solid 4px #f5c644;\r\n}\r\n\r\n\r\n.box-outline-lg{\r\n  width: 70em;\r\n  height: 516px;\r\n \r\n  \r\n  border: solid 4px #21929b;\r\n \r\n}\r\n\r\n.box-outline-lg-sm{\r\n  width: 1058px;\r\n  height: 516px;\r\n \r\n  \r\n  border: solid 4px #21929b;\r\n \r\n}\r\n\r\n.box-outline-lg:hover{\r\n  width: 70em;;\r\n  height: 516px;\r\n \r\n  \r\n  border: solid 4px #f5c644;\r\n \r\n}\r\n\r\n\r\n.box-outline-head{\r\n  background-color: #21929b;\r\n  height: 77px;\r\n  font-size: 40px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  \r\n  color: #fff;\r\n}\r\n\r\n.box-outline-head:hover{\r\n  background-color: #f5c644;\r\n  height: 77px;\r\n  font-size: 40px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  \r\n  color: #fff;\r\n}\r\n\r\n.intro-label{\r\n  \r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n}\r\n\r\n.box-body-lg{\r\n  width: 700px;\r\n  height: 320px;\r\n  margin-top: 5px;\r\n  border-radius: 6px;\r\n  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);\r\n  border: solid 1.1px #f7f7f4;\r\n  background-color: #f7f7f4;\r\n  \r\n}\r\n\r\n.box-outline-yellow{\r\n  width: 220px;\r\n  height: 200px;\r\n  padding: 12px 19px 33px 29px;\r\n  border-radius: 6px;\r\n  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);\r\n  border: solid 1.1px #fec402 ;\r\n  background-color: #fec402 ;\r\n}\r\n\r\n.box-body{\r\n  width: 200px;\r\n  height: 170px;\r\n  margin-top: 5px;\r\n  border-radius: 6px;\r\n  box-shadow: 3px 3px 15px -3px rgba(96, 125, 141, 0.5);\r\n  border: solid 1.1px #f7f7f4;\r\n  background-color: #f7f7f4;\r\n  \r\n}\r\n\r\n.title-style{\r\n \r\n  height: 27px;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  \r\n  color: #fff;\r\n  \r\n}\r\n\r\n.guess-class{\r\n  background-color: #f1f1f1;\r\n  width: 500px;\r\n  height: 230px;\r\n  padding: 20px;\r\n  font-size: 20px;\r\n}\r\n\r\n.title-style-unbold{\r\n  width: 348px;\r\n  height: 27px;\r\n  font-size: 1.3em;\r\n  \r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  \r\n  color: #fff;\r\n  \r\n}\r\n\r\n.title-bg{\r\n  background-color: #21929b;\r\n  height: 57px;\r\n  text-align: center;\r\n}\r\n\r\n.title-bg:hover{\r\n  background-color: #fec402;\r\n  height: 57px;\r\n  text-align: center;\r\n}\r\n\r\n\r\n.description-style{\r\n \r\n \r\n  margin-top: 2%;\r\n  font-size: 20px;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #fff;\r\n  overflow-y: auto;\r\n  padding: 10px;\r\n}\r\n\r\n.right-intro-div{\r\n  width: 315px;\r\n  height: 330px;\r\n  margin: 0 0 0 442px;\r\n  padding: 0px 14px 8px 12px;\r\n  opacity: 0.8;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 9px 1px rgba(65, 91, 104, 0.5);\r\n  border: solid 2px #1293f6;\r\n  background-color: #162e3a;\r\n}\r\n\r\n/* .intro-div{\r\n  background-image: url(./images/udl-bg-female.png);\r\n  background-repeat: no-repeat;\r\n  width: 100%;\r\n  padding-bottom: 20vh;\r\n} */\r\n\r\n.white-label{\r\n  \r\n  height: 22.5px;\r\n  font-family: Ubuntu;\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 0.94;\r\n  letter-spacing: normal;\r\n  color: #ffffff;\r\n  text-align: center;\r\n}\r\n\r\n.bg-class{\r\n  \r\n  /* background-image: url('https://udl-boe.eu/wp-content/uploads/2021/05/cropped-homepage-3.jpg'); */\r\n  width: 100%;\r\n  padding-top: 10px;\r\n  height: 900px;\r\n  /* background-image: url('./images/udl-bg.PNG'); */\r\n  background: rgb(2,0,36);\r\n\r\n  background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(174,174,187,1) 35%, rgba(0,212,255,1) 100%);\r\n \r\nbackground-repeat:round;\r\n \r\n}\r\n\r\n.sv_qstn .sq-root {\r\n  border: 10px solid gray;\r\n  border-left: 4px solid #18a689;\r\n  border-radius: 5px;\r\n  padding: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.sq-root-ba{\r\n  background-color: pink;\r\n}\r\n\r\n.title_ba{\r\n  background-color: #21929b;\r\n  height: 7em !important;\r\n \r\n  margin-top: -1.7em;\r\n  width: 30em;\r\n  color: white;\r\n  font-family: Arial;\r\n  font-size: 20px;\r\n  padding-left: 2em;\r\n  padding-top: 0.5em;\r\n  margin-bottom:5px;\r\n  position: static;\r\n  margin-left: -2em !important;\r\n\r\n\r\n}\r\n\r\n.radiogroup_item_control{\r\n  visibility: hidden;\r\n}\r\n\r\n\r\n\r\n\r\n/* change this to selected default */\r\n\r\n/* By default radio button class */\r\n\r\n\r\n\r\n.uncheckedradio{\r\n \r\n  width: 95%;\r\n  height: 35px;\r\n  margin-top: 10px;\r\n  margin-left: 2%;\r\n  margin-right: 25%;\r\n  cursor: pointer;\r\n  background-color: #e0e2e2;\r\n  padding: -0.1em;\r\n} \r\n\r\n.radioLabel{\r\n  color: black;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  height: 25px;\r\n  \r\n  padding-top: 7px;\r\n  margin-bottom: 10px;\r\n  font-family: Ubuntu;\r\n  font-size: 16px;\r\n}\r\n\r\n\r\n\r\n.uncheckedradio:checked{\r\n  color: white;\r\n}\r\n\r\n.checkedradio{\r\n  \r\n  width: 95%;\r\n  \r\n  margin-top: 10px;\r\n  margin-left: 2%;\r\n  margin-right: 25%;\r\n  /* color : white !important; */\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.uthOye{\r\n  \r\n    color: black;\r\n    cursor: pointer;\r\n    background-color: pink;\r\n    width: 100%;\r\n    height: 40px;\r\n    padding-left: 15px;\r\n    padding-top: 10px;\r\n    margin-bottom: 10px;\r\n    color: white\r\n  \r\n}\r\n\r\n\r\n.radioroot{\r\n  cursor: pointer !important;\r\n}\r\n\r\n\r\n\r\n/* .checkedradio{\r\n  background-color: #007ac0;\r\n  width: 95%;\r\n  height: 40px;\r\n  margin-top: 10px;\r\n  margin-left: 2%;\r\n  margin-right: 25%;\r\n  padding: 5px;\r\n  cursor: pointer;\r\n  \r\n} */\r\n\r\n\r\n\r\n.checked-label{\r\n  /* background-color: pink; */\r\n  height: 40px;\r\n  color: #f1f1f1 !important;\r\n  background-color: #007ac0;\r\n  cursor: pointer;\r\n}\r\n\r\n.unchecked-label{\r\n  background-color: olive;\r\n  width: 100% !important;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* on hover of selecting an option from list */\r\n/* .default:hover{\r\n  background-color: #007ac0;\r\n  cursor: pointer !important;\r\n} */\r\n\r\n/* on hover of  label of option from*/\r\n\r\n\r\n/* .sd-item__control-label:hover\r\n{\r\n background-color: #007ac0;\r\n cursor: pointer;\r\n} */\r\n\r\n\r\n\r\n\r\n\r\n\r\n.checked{\r\n  background-color: #007ac0;\r\n  width: 95%;\r\n  height: 40px;\r\n  margin-top: 10px;\r\n  margin-left: 2%;\r\n  margin-right: 25%;\r\n  padding: 5px;\r\n  cursor: pointer !important;\r\n  \r\n}\r\n\r\n\r\n\r\n/* This hides the radio butotn circles */\r\n.sd-radio__decorator{\r\n  visibility: hidden;\r\n  \r\n}\r\n\r\n/* Culprit class */\r\n.sd-selectbase__label{\r\n\r\ncursor: pointer;  \r\n}\r\n\r\n/* .sd-item__control-label{\r\n \r\n\r\nfont-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\nfont-style: normal;\r\nfont-weight: normal;\r\nline-height: calc(3 * var(--base-unit, 8px));\r\nfont-size: calc(2 * var(--base-unit, 8px));\r\nmargin-left: calc(1 * var(--base-unit, 8px));\r\nwhite-space: normal;\r\nword-break: break-word;\r\nbackground-color: yellow;\r\n\r\n} */\r\n\r\n.selectedradioclass{\r\n \r\n\r\n  font-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  line-height: calc(3 * var(--base-unit, 8px));\r\n  font-size: calc(2 * var(--base-unit, 8px));\r\n  margin-left: calc(1 * var(--base-unit, 8px));\r\n  white-space: normal;\r\n  word-break: break-word;\r\n  background-color: pink;\r\n  \r\n  }\r\n\r\n\r\n\r\n\r\n.box-style{\r\n  background-color: white;\r\n  border: 1px solid black;\r\n  height: 45px;\r\n  margin-left: 20px;\r\n}\r\n\r\n\r\n.tick-style{\r\n  font-weight: bold;\r\n  font-family: Ubuntu;\r\n  font-size: 30px;\r\n  color: #162e3a;\r\n  padding: 20px;\r\n}\r\n\r\n.rec-label{\r\n  font-family: Ubuntu;\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.25;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #18a689;\r\n}\r\n\r\n.head-style{\r\n  font-family: Ubuntu;\r\n  font-size: 44px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.25;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #18a689;\r\n}\r\n\r\n\r\n/* sd-description sd-question__description */\r\n.sd-question__description-ba{\r\n  \r\n  border: 1px solid black;\r\n  width: 40%;\r\n  margin-left: 30%;\r\n  height: 200px;\r\n  padding: 25px;\r\n  border-bottom: 7px solid #007ac0;\r\n  font-weight: bold;\r\n  \r\n}\r\n\r\n.myclassba{\r\n  border: 1px solid black;\r\n  width: 91%;\r\n  /* margin-left: 10%; */\r\n  height: -moz-fit-content;\r\n  height: fit-content;\r\n  padding-top: 1em;\r\n  padding-bottom: 1em;\r\n  padding-left: 3em;\r\n  border-bottom: 7px solid #007ac0;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  white-space: initial;\r\n}\r\n\r\n.default-checkbox{\r\n  background-color: #f1f1f1;\r\n  width: 90%;\r\n  /* height: 150px; */\r\n  margin-top: 10px;\r\n  margin-left: 5%;\r\n  margin-right: 25%;\r\n  padding: 5px; \r\n\r\n  font-family: Ubuntu;\r\n  font-size: 16px;\r\n  \r\n  \r\n}\r\n\r\n.default-checkbox:hover{\r\n  background-color: #19b394;\r\n  /* min-width: 200%; */\r\n  /* height: 150px; */\r\n  margin-top: 10px;\r\n  margin-left: 5%;\r\n  margin-right: 25%;\r\n  padding: 5px; \r\n  color : white;\r\n  height: fit-content;\r\n  font-family: Ubuntu;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n\r\n.sd-checkbox__decorator{\r\n  visibility: hidden;\r\n}\r\n\r\n/* progress bar on top style class */\r\n.sd-progress__bar{\r\nheight: 80px !important; \r\n/* background-color: #007ac0 !important; */\r\n/* position: fixed !important; */\r\n\r\n\r\n}\r\n\r\n/* Hide the nouislider slider button to avoid UI issues */\r\n.noUi-handle{\r\n  \r\n  visibility: hidden;\r\n}\r\n\r\n/* question title class */\r\n.sv-string-viewer{\r\n  white-space: initial;\r\n  cursor: pointer;\r\n  \r\n  \r\n}\r\n\r\n\r\n\r\n.bg-class {\r\n  /* background-image: url(https://udl-boe.eu/wp-content/uploads/2021/05/cropped-homepage-3.jpg); */\r\n  /* width: 100%; */\r\n  /* padding-top: 0px; */\r\n  /* height: 900px; */\r\n  /* background-image: url(./images/udl-bg.PNG); */\r\n  /* background: rgb(2,0,36); */\r\n  /* background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(174,174,187,1) 35%, rgba(0,212,255,1) 100%); */\r\n  \r\n  padding-top: 5px;\r\n  height: 100%;\r\n  \r\n  background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(174,174,187,1) 35%, rgba(0,212,255,1) 100%);\r\n}\r\n\r\n\r\n\r\n.inner-circle{\r\n  width: 76px;\r\n  height: 76px;\r\n  margin: 0 43px 29px 41px;\r\n  background-image: linear-gradient(312deg, #1293f6 104%, #5dd1ba -2%);\r\n  border-radius: 50%;\r\n  z-index: 5;\r\n  position: relative;\r\n}\r\n\r\n.outer-circle{\r\nbackground-color: #5dd1ba;\r\nwidth: 86px;\r\n  height: 86px;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  top: 19%;\r\n  left: 2.9%;\r\n  z-index: 4;\r\n}\r\n\r\n.outer-2nd-circle{\r\n  background-color: #5dd1ba;\r\n    width: 96px;\r\n    height: 96px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 18.2%;\r\n    left: 2.6%;\r\n    position: absolute;\r\n    z-index: 3;\r\n    opacity: 0.5;\r\n}\r\n\r\n/* Input Text Fields, change design using their specific ids  */\r\n\r\n\r\n  .main-section {\r\n    background-image: url(./images/udl-bg-female.png);\r\n    background-size: cover;\r\n    height: 37em;\r\n  }\r\n\r\n\r\n \r\n\r\n  /* FOR SMALL SCREENS */\r\n  @media only screen and (max-width: 1919px)\r\n   \r\n \r\n   \r\n \r\n   \r\n \r\n   {\r\n\r\n    \r\n\r\n    .footer{\r\n        \r\n      border: 2px solid black;\r\n      position: fixed !important;\r\n      bottom: 0;\r\n    }\r\n\r\n    .surveybox{\r\n       \r\n        height: 50em !important;\r\n    }\r\n\r\n    .demographicbox{\r\n      height: 350em !important;\r\n      z-index: inherit;\r\n      overflow-y: scroll;\r\n    }\r\n\r\n    .title-style-unbold{\r\n      width: 348px;\r\n      height: 27px;\r\n      font-size: 0.9em;\r\n      \r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: normal;\r\n      letter-spacing: normal;\r\n      \r\n      color: #fff;\r\n      \r\n    }\r\n\r\n    .results-head {\r\n      width: 100%;\r\n      height: 91px;\r\n      text-align: center;\r\n      background-color: #21929b;\r\n      padding-top: 1%;\r\n      \r\n  }\r\n\r\n    .surveybox{\r\n      \r\n      overflow-y: auto;\r\n    }\r\n\r\n\r\n    .sd-row__question {\r\n      box-sizing: border-box;\r\n      width: 100%;\r\n      white-space: nowrap;\r\n      height: fit-content !important;\r\n      margin-top: 20px;\r\n      padding-bottom: 3em !important;\r\n    }\r\n\r\n\r\n    .box-outline-lg {\r\n      width: 70em;\r\n      height: 18.7em;\r\n      border: solid 4px #21929b;\r\n  }\r\n\r\n  .box-outline-lg:hover{\r\n    height: 18.7em;\r\n  }\r\n\r\n  .title_ba {\r\n    background-color: #21929b;\r\n    height: 4em;\r\n    margin-left: -2.0em;\r\n    margin-top: -1.7em;\r\n    width: 30em;\r\n    color: white;\r\n    font-family: Arial;\r\n    font-size: 20px;\r\n    padding-left: 2em;\r\n    padding-top: 0.5em;\r\n    margin-bottom: 5px;\r\n    \r\n}\r\n\r\n.myclassba {\r\n  border: 1px solid black;\r\n  width: 91%;\r\n  margin-left: 0.3%;\r\n  height: -moz-fit-content;\r\n  height: fit-content;\r\n  padding-top: 1em;\r\n  padding-bottom: 2em;\r\n  padding-left: 3em;\r\n  border-bottom: 7px solid #007ac0;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  white-space: initial;\r\n  margin-bottom: 1em;\r\n \r\n}\r\n\r\n  .intro-label {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #fff;\r\n}\r\n\r\n \r\n\r\n\r\n\r\n  .affiliation-div\r\n{\r\n  height: 2em  !important;\r\n  background-image: linear-gradient(to right, #f5c644  , orange); \r\n}\r\n\r\n \r\n\r\n  .btn-main-section{\r\n      margin-top:-13px;\r\n  }\r\n\r\n  .nav-bar-div{\r\n    width: 100%;\r\n    height: 6em;\r\n    background-image: linear-gradient(to right, #3870b8  , #333332);\r\n    \r\n  }\r\n\r\n  /* 1920 */\r\n  .udl-logo{\r\n    height: 3.5em;\r\n    margin-left: 2em;\r\n  }\r\n\r\n  .udl-title{\r\n    font-family: Arial;\r\n    font-size: 32px;\r\n    font-weight: bold;\r\n    font-stretch: normal;\r\n    \r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #f7f7f7;\r\n    margin : 1em;\r\n  }\r\n\r\n  .flags-bg {\r\n    width: 100%;\r\n    height: 4em;\r\n    background-color: #333;\r\n}\r\n\r\n\r\n\r\n\r\n  .main-section {\r\n    background-color: lightblue;\r\n    height: 28em;\r\n  }\r\n\r\n  .box-outline{\r\n    margin-top: -20px;\r\n    width: 17em;\r\n    height: 15em;\r\n    border: solid 4px #21929b;\r\n  }\r\n\r\n  .box-outline:hover{\r\n    width: 17em;\r\n    height: 15em;\r\n    border: solid 4px #f5c644;\r\n  }\r\n\r\n  .title-bg{\r\n    background-color: #21929b;\r\n    height: 3em;\r\n    text-align: center;\r\n  }\r\n\r\n  .title-style{\r\n \r\n    \r\n    font-size: 1.2em;\r\n    font-weight: bold;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    \r\n    color: #fff;\r\n    \r\n  }\r\n\r\n\r\n  .description-style{\r\n \r\n \r\n    margin-top: 2%;\r\n    font-size: 0.9em;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #fff;\r\n    overflow-y: auto;\r\n    padding: 10px;\r\n  }\r\n\r\n\r\n  .footer-div{\r\n    position: fixed;\r\n    bottom:0;\r\n    width: 100%;\r\n   }\r\n\r\n   .affiliation-div{\r\n    border:1px solid red;\r\n    position: fixed;\r\n    bottom:4em !important;\r\n   }\r\n\r\n\r\n\r\n   .dynoersmaindiv{\r\n      \r\n    margin-left: 5em !important;\r\n    overflow-y: auto;\r\n    \r\n  }\r\n\r\n  .results-bar-2{\r\n   \r\n    height: 340em !important;\r\n  }\r\n\r\n  .smallscreenfooter{\r\n    border: 10px solid red;\r\n    display: none;\r\n  }\r\n\r\n  .sd-progress__bar {\r\n    height: 10px !important;\r\n}\r\n\r\n\r\n  }\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n  .intro-div{\r\n    background-image: url(./images/udl-bg-female.png);\r\n    background-size: cover;\r\n    height: 47em !important;\r\n   \r\n  }\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.results-head{\r\n  width: 100%;\r\n  height: 121px;\r\n  text-align: center;\r\n  background-color: #21929b;\r\n  padding-top: 1%;\r\n}\r\n\r\n.results-subhead{\r\n  width: 100%;\r\n  height: 75px;\r\n  \r\n  background-color: #5aaeb5;\r\n}\r\n\r\n.likert-style{\r\n  width: 191px;\r\n  height: 42px;\r\n  padding-top: 0.7%;\r\n  background-color: #cb300d;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #fff;\r\n}\r\n\r\n\r\n.results-donut{\r\n  width: 100%;\r\n  height: 20em;\r\n\r\n  background-color: #b0d8dc;\r\n\r\n  padding-top: 3em;\r\n}\r\n\r\n.donut-box{\r\n  width: 25em;\r\n  height: 229px;\r\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\r\n  background-color: #fff;\r\n  \r\n}\r\n\r\n.overview-lbl{\r\n  font-size: 32px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n\r\n}\r\n\r\n\r\n.overview-lbl-unb{\r\n  font-size: 28px;\r\n\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n\r\n}\r\n\r\n\r\n.overview-lbl-sm{\r\n  font-size: 1.2  em;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n  \r\n}\r\n\r\n.donut-style{\r\n  width: 234px;\r\n  height: 118px;\r\n  object-fit: contain;\r\n  margin-top: 5%;\r\n}\r\n\r\n.results-bar{\r\n  width: 99.5%;\r\n  height: 289px;\r\n  \r\n  border: solid 4px #21929b;\r\n  background-color: #fff;\r\n}\r\n\r\n.results-bar-2{\r\n  width: 99.5%;\r\n  height: 590px;\r\n  \r\n  border: solid 4px #21929b;\r\n  background-color: #fff;\r\n}\r\n\r\n.bar-div{\r\n  width: 485px;\r\n  height: 211px;\r\n  \r\n\r\n\r\n}\r\n\r\n.yellowButton-sm{\r\n  \r\n  height: 56px;\r\n  padding: 14px 45px 13px;\r\n  border-radius: 10px;\r\n  background-color: #f5c644;\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.noUi-connect{\r\nbackground: #19b394 !important;\r\n}\r\n\r\n\r\n\r\n.testingclassess{\r\n  background-color: oldlace;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.launch-btn{\r\n  width: 257px;\r\n  height: 56px;\r\n  border-radius: 10px;\r\n  border: solid 3px black;\r\n  background-color: #f5c644;\r\n  \r\n}\r\n\r\n.launch-btn-text{\r\n  width: 220px;\r\n  height: 39px;\r\n  font-family: Ubuntu;\r\n  font-size: 32px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n  text-decoration: none;\r\n  padding: 9px 18px 8px 19px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\niframe {\r\n  border: 10px solid black;\r\n}\r\n\r\n\r\n.HeadingText{\r\n \r\n  font-family: Ubuntu;\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #fff;\r\n  padding: 15px;\r\n  text-decoration: none;\r\n}\r\n\r\n.cookie-btn{\r\n  background: rgb(255, 212, 45);\r\n    border: 0px;\r\n    border-radius: 0px;\r\n    box-shadow: none;\r\n    color: black;\r\n    cursor: pointer;\r\n    flex: 0 0 auto;\r\n    padding: 5px 10px;\r\n    margin: 17px;\r\n  \r\n}\r\n\r\n\r\n\r\n/* Remove page number appearing for pages of survey */\r\n.sd-progress__text{\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n/* Media Query for Survey questions*/\r\n@media only screen and (min-width: 1920px)\r\n {\r\n\r\n  .results-bar-2{\r\n      \r\n      height: 242em ;\r\n  }\r\n\r\n  .footer{\r\n      width: 100% ;\r\n  }\r\n\r\n  .intro-div{\r\n    background-image: url(./images/udl-bg-female.png);\r\n    background-size: cover;\r\n    height : 70em !important;\r\n   \r\n  }\r\n  .main-section {\r\n   height: 70em;\r\n  }\r\n\r\n  /* .demographicbox{ */\r\n    /* border : 20px solid orange; */\r\n    /* height: 195em; */\r\n    /* z-index: 100000 !important; */\r\n  /* } */\r\n\r\n}\r\n\r\n\r\n\r\n.sv-radio-checked .sv-radio-svg{\r\n  background-color: red !important;\r\n  color : white !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.affiliation-div\r\n{\r\n  height: 5em;\r\n  background-image: linear-gradient(to right, #f5c644  , orange);\r\n  padding : 0.5em;\r\n}\r\n\r\n.affiliation-div p {\r\n\r\n  font-family: Ubuntu;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #333;\r\n  margin-left: 10px;\r\n  margin-top:0px;\r\n}\r\n\r\n\r\n.sd-body{\r\nmargin-top: -40px;\r\n\r\nbackground-color: #525252;\r\n/* z-index: 99999999 !important; */\r\n\r\n}\r\n\r\n\r\n.sd-root-modern {\r\n  --sd-mobile-width: 600px;\r\n  width: 100%;\r\n  font-family: 'Ubuntu';\r\n  background-color: var(--background-dim, #f3f3f3);\r\n}\r\n\r\n.radioLabel:hover{\r\n  color: white;\r\n  cursor: pointer;\r\n  background-color: #19b394;\r\n  width: 100%;\r\n  height: 25px;\r\n  padding-left : 1.6em;\r\n  padding-bottom: 0.2em;\r\n  margin-left : -1.6em;  \r\n  font-weight: bold;\r\n \r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.checked-checkbox{\r\n  background-color: #19b394;\r\n  min-width: 90%;\r\n  /* height: 150px; */\r\n  margin-top: 10px;\r\n  margin-left: 5%;\r\n  margin-right: 25%;\r\n  padding: 5px; \r\n  \r\n  color : white;\r\n\r\n  height: fit-content;\r\n  font-family: Ubuntu;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n \r\n}\r\n\r\n.sd-dropdown.sd-input{\r\n  background-color: pink;\r\n\r\n}\r\n\r\n.sd-dropdown.sd-input:hover{\r\n  background-color :#19b394;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color : white;\r\n  \r\n}\r\n\r\n.sd-dropdown.sd-input{\r\n  background-color: #19b394;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  color : white !important;\r\n  height: 3.3em;\r\n  \r\n}\r\n\r\n\r\n\r\n/* .sv_q_text_root{\r\n  background-color: #19b394 !important;\r\n  width : 21em;\r\n  height: 50px;\r\n  color: white;\r\n  font-family: Ubuntu;\r\n  font-weight: bold;\r\n  font-size: 25px;\r\n} */\r\n\r\n/* https://stackoverflow.com/questions/4113965/css-selector-for-text-input-fields */\r\n/* Answe on this link, help to sort out issue of input text field */\r\n[type=text]{\r\n  height: 50px !important;\r\n  width: 35em !important;\r\n  background-color: #19b394;\r\n  font-weight: bold;\r\n  font-size: 25px;\r\n  color : white;\r\n}\r\n\r\n\r\n\r\n  .oer-parent{\r\n    width: 22em;\r\n    height: 28em;\r\n    margin-left: 15px;\r\n    margin-top: 15px;\r\n    border: solid 4px #e0e2e2;\r\n    background-color: #fff;\r\n    border : 1px solid black;\r\n  }\r\n\r\n  .oer-subhead{\r\n    width: 22em;\r\n    height: 5em;\r\n    background-color: #e0e2e2;\r\n    display: flex;\r\n  }\r\n\r\n  .oer-img{\r\n    width: 3em;\r\n    height: 3em;\r\n    object-fit: contain;\r\n    padding : 0.5em;\r\n  }\r\n\r\n  .oer-title-style{\r\n    width: 20em;\r\n    height: 122px;\r\n    padding: 0.5em;\r\n    font-family: Ubuntu;\r\n    font-size: 1.2em;\r\n    font-weight: bold;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: var(--black);\r\n  }\r\n\r\n  .oer-cluster{\r\n    width: 22em;\r\n    height: 2.5em;\r\n    background-color: #705c98;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-top: 0.5em;\r\n  }\r\n\r\n  .cluster-text{\r\n  \r\n    \r\n    font-family: Ubuntu;\r\n    font-size: 1.4em;\r\n    font-weight: bold;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #fff;\r\n    \r\n  }\r\n\r\n  .oer-details{\r\n    width: 20em;\r\n    height: 170px;\r\n    margin: 25px 28px 25px 19px;\r\n    font-family: Ubuntu;\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: var(--black);\r\n   \r\n  }\r\n\r\n\r\n  .selectlangclass{\r\n    width: 15em;\r\n    height: 1.5em;\r\n    font-family: Ubuntu;\r\n    font-size: 1.4em;\r\n    font-weight: bold;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    background-color: #f5c644;\r\n   \r\n  }\r\n\r\n  .selectlangclass option{\r\n    background-color: #21929b;\r\n    \r\n    \r\n  }\r\n\r\n\r\n\r\n  /* Page box class for surveyjs September 2022 */\r\n  .sd-page{\r\n    \r\n    margin-top: -60px;\r\n    height: fit-content;\r\n    \r\n    \r\n  }\r\n\r\n  .sd-btn{\r\n    margin-top: -30px;\r\n    \r\n    height: 2.5em !important;\r\n    background-color: #f5c644 !important;\r\n    font-family: Ubuntu !important;\r\n    color: black !important;\r\n    font-size: 22px !important;\r\n    border: 1px solid orange !important;\r\n   \r\n  }\r\n\r\n  .sd-btn:hover{\r\n    background-color:  orange !important;\r\n    border: 1px solid orange !important;\r\n  }\r\n\r\n \r\n\r\n \r\n\r\n\r\n  /* Options Section in Multiple Choice UDL BOE Question */\r\n  .sd-question__content{\r\n    \r\n    margin-bottom: -35px;\r\n    margin-top: -10px;\r\n  }\r\n\r\n  \r\n\r\n  .sd-description{\r\n    \r\n    font-family: Ubuntu !important;\r\n    color: white !important;\r\n    font-size: 22px !important;\r\n    font-weight: bold !important;\r\n    \r\n    padding-top: 5px;\r\n  }\r\n \r\n\r\n.noUi-value{\r\n    \r\n    font-family: Ubuntu !important;\r\n    font-size: 22px !important;\r\n    font-weight: bold !important;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.yellowButton:hover{\r\n  background-color: orange;\r\n}\r\n\r\n.yellowButton-sm:hover{\r\n  background-color: orange;\r\n}\r\n\r\n.launch-btn:hover{\r\n  background-color: orange;\r\n}\r\n\r\n\r\n.launch-btn-text-new{\r\n  width: 220px;\r\n  height: 29px;\r\n  font-family: Ubuntu;\r\n  font-size: 32px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n  text-decoration: none;\r\n  padding: 0px 18px 8px 19px;\r\n}\r\n\r\n\r\n/* .radioLabel .default-checkbox .oer-details .oer-details{\r\n  font-weight: bold !important;\r\n  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;\r\n  background-color: pink !important;\r\n} */\r\n\r\n .oer-details{\r\n  \r\n  font-family: Ubuntu !important;\r\n}\r\n\r\n.oer-title-style{\r\n  font-family: Ubuntu !important;\r\n}\r\n\r\n.radioLabel{\r\n  font-family: Ubuntu !important;\r\n}\r\n\r\n.default-checkbox {\r\n  font-family: Ubuntu !important;\r\n}\r\n\r\n\r\n@media only screen and (max-height: 1080px) and (min-width: 1920px){\r\n  .title_ba {\r\n    background-color: #21929b;\r\n    height: 4em;\r\n    margin-top: -1.7em;\r\n    width: 30em;\r\n    color: white;\r\n    font-family: Arial;\r\n    font-size: 20px;\r\n    margin-bottom: 5px;\r\n    position: static;\r\n    margin-left: -2em !important;\r\n}\r\n\r\n\r\n}\r\n\r\n\r\n\r\n/* VERY LARGE SCREEN */\r\n@media only screen and (min-width: 2560px){\r\n  .results-bar-2{\r\n      \r\n    height: 182em !important;\r\n  }\r\n\r\n /* VERY LARGE SCREEN */\r\n@media only screen and (min-width: 2560px){\r\n  .results-bar-2{\r\n      \r\n    height: 182em !important;\r\n  }\r\n\r\n \r\n\r\n\r\n\r\n}\r\n\r\n.yellowButtonText {\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #333;\r\n}\r\n\r\n\r\n\r\n}\r\n\r\n\r\n\r\n.sd-footer{\r\n\r\n\r\njustify-content: right;\r\n}\r\n\r\n\r\n\r\n.table{\r\n  border: 2px solid black;\r\n  width: 100%;\r\n}\r\n\r\n.tr{\r\n  border: 2px solid black;\r\n}\r\n\r\n.td{\r\n  border: 2px solid black;\r\n}\r\n\r\n\r\n\r\n.checkedradio .radioLabel{\r\n  background-color: #19b394;\r\n  color: white;\r\n  font-weight: bold;\r\n  padding-left : 1.6em;\r\n  height: 30px;\r\n  margin-left : -1.5em;\r\n  width: 200% !important;\r\n}\r\n\r\n\r\n.sd-progress-buttons__list{\r\n/* background-color: pink; */\r\n/* display: none !important; */\r\nmargin-bottom: 20px !important;\r\n\r\n}\r\n\r\n\r\n.sd-progress-buttons__footer .sd-progress-buttons__page-title{\r\n background-color: red;\r\n display: none \r\n}\r\n\r\n\r\n.sv-components-row>.sv-components-column--expandable{\r\n  background-color: #525252 !important;\r\n}\r\n\r\n\r\n\r\n\r\n.checkedradio .radioLabel{\r\n  background-color: #19b394;\r\n  color: white;\r\n  font-weight: bold;\r\n  height: 30px;\r\n  \r\n  width: 30em !important;\r\n  margin-left: -2em !important;\r\n}\r\n\r\n\r\n.radioLabel:hover{\r\n  background-color: #19b394;\r\n  color: white;\r\n  font-weight: bold;\r\n  height: 30px; \r\n  \r\n  width: 30em !important;\r\n  margin-left: -2em !important;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n.sd-progress-buttons__list .sd-progress-buttons__list-element--current .sd-progress-buttons__button .sd-progress-buttons__button-content {\r\n  border: calc(0.5 * (var(--sjs-base-unit, var(--base-unit, 18px)))) solid var(--sjs-primary-backcolor, var(--primary, #19b394));\r\n  background-color: var(--sjs-primary-forecolor, var(--primary-foreground, #fff));\r\n  opacity: 1;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n  .radioLabel{\r\n    /* border: 2px solid red; */\r\n    width: 30em !important;\r\n    margin-left: -30px;\r\n    padding-left: 25px;\r\n    \r\n  }\r\n\r\n\r\n  /* Final change for consistency of hover */\r\n.radioLabel:hover .uncheckedradio:hover {\r\n  background-color: rgb(192, 255, 218);\r\n  color: red;\r\n  font-weight: bold;\r\n  padding: 500px !important;\r\n  }\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
